import logo from './logo/ainxt_logo.png';
import './App.css';
import { useEffect, useState } from 'react';
import DecryptAES from './app/crypto';


function App() {
  const params = new URLSearchParams(window.location.search);
  const no_of_holders = parseInt(params.get("no_of_holders")) || 0;
  const current_holder = parseInt(params.get("current_holder")) || 0;
  const [param, setParam] = useState("");
  const [data, setData] = useState({})

  useEffect(() => {
    const queryString = window.location.search;
    const rawParam = queryString.match(/[?&]txnref=([^&]*)/)?.[1];  // Regex to get raw value
    let ans = DecryptAES(rawParam, "L3I1yiju3ulFyod500j9zC", "UUxd2XCAe39PYqetCgyE6O8");
    // console.log("Decrypted value:", ans);
    setParam(rawParam);
    setData(JSON.parse(ans));
  }, [])

  // console.log(data);

  const handleCall = () => {
    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "oDQIeXiKOV5ufK2GmGrse7zpuuxHCSUo8j0QpLPe");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "data": param
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch("https://multiesignserviceuat.ainxtapi.com/esign/holder_request", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status === true) {
          window.location.assign(result.data);
        } else {
          alert("Some error occurred. Please try again later.");
        }
      })
      .catch((error) => console.error(error));
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="ainxt_logo" className="logo" />
      </header>
      <div className='sidebox'>
        <h1 className='heading1'>Please continue with the current holder Esign</h1>
        <div className='boxes'>
          {[...Array(data?.no_of_holders)].map((_, i) => {
            let buttonClass = "box1";
            let content = `Holder ${i + 1}`;

            if (i < current_holder - 1) {
              buttonClass += " active";
              content = `✅ ${content}`;
            } else if (i === data?.current_holder - 1) {
              buttonClass += " current-last";
            }

            return (
              <button
                key={i}
                className={buttonClass}
                // onClick={i === data?.current_holder - 1 ? () => window.open("https://www.flipkart.com/", "_blank") : undefined}
                onClick={handleCall}
              // disabled={i !== current_holder - 1} // optionally make others visually disabled
              >
                {content}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );

}

export default App;

// import { useEffect, useState } from "react";
// import logo from './logo/ainxt_logo.png';
// import './App.css';
// import api from './config';  

// function App() {
//   // ---- State ----
//   const [txnref, setTxnref] = useState(null);
//   const [error, setError] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [redirectUrl, setRedirectUrl] = useState("");
//   const [closedUrl, setClosedUrl] = useState("");

//   const queryString = window.location.search;
//   const params = new URLSearchParams(queryString);

//   // ---- Param extraction ----
//   const rawParam = queryString.match(/[?&]txnref=([^&]*)/)?.[1] || null;
//   const decodedParam = rawParam ? decodeURIComponent(rawParam) : null;

//   const no_of_holders = parseInt(params.get("no_of_holders")) || 0;
//   const current_holder = parseInt(params.get("current_holder")) || 0;

//   // ---- API Call (like PdfViewer) ----
//   useEffect(() => {
//     if (!rawParam) return;

//     setTxnref(rawParam);

//     async function fetchPdfAccess() {
//       setLoading(true);
//       try {
//         const url = api.uat.url;
//         const data = { data: rawParam };

//         const response = await fetch(url, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             'x-api-key': api.uat.x_api_key,
//           },
//           body: JSON.stringify(data),
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const result = await response.json();
//         if (result.status === true) {
//           setRedirectUrl(result.redirectUrl);
//           setClosedUrl(result.close_redirectUrl);
//           setError(false);
//         } else {
//           setError(true);
//         }
//       } catch (err) {
//         console.error("Error:", err);
//         setError(true);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchPdfAccess();
//   }, [rawParam]);

//   // ---- Build new encoded txnref with holder info ----
//   const buildEncodedTxnref = (nextHolder) => {
//     let payload = {
//       txnref: decodedParam,
//       no_of_holders,
//       current_holder: nextHolder,
//     };
//     return encodeURIComponent(JSON.stringify(payload));
//   };

//   // ---- Error case ----
//   if (!txnref) {
//     return (
//       <div className="App">
//         <h2 style={{ color: "red" }}>Token missing: Please add valid token</h2>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="App">
//         <h2 style={{ color: "red" }}>Invalid data: Please check and try again</h2>
//       </div>
//     );
//   }

//   // ---- Loading ----
//   if (loading) {
//     return (
//       <div className="App flex justify-center items-center h-screen">
//         <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500"></div>
//       </div>
//     );
//   }

//   // ---- Holders UI ----
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} alt="ainxt_logo" className="logo" />
//       </header>

//       <div className="sidebox">
//         <h1 className="heading1">
//           Please continue with the current holder Esign
//         </h1>

//         <div className="boxes">
//           {[...Array(no_of_holders)].map((_, i) => {
//             let buttonClass = "box1";
//             let content = `Holder ${i + 1}`;

//             if (i < current_holder - 1) {
//               buttonClass += " active";
//               content = `✅ ${content}`;
//             } else if (i === current_holder - 1) {
//               buttonClass += " current-last";
//             }

//             return (
//               <button
//                 key={i}
//                 className={buttonClass}
//                 onClick={
//                   i === current_holder - 1
//                     ? () => {
//                       const newTxnref = buildEncodedTxnref(i + 1);
//                       // use redirectUrl from API + new encoded param
//                       window.open(
//                         `${redirectUrl}?txnref=${newTxnref}`,
//                         "_blank"
//                       );
//                     }
//                     : undefined
//                 }
//               >
//                 {content}
//               </button>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;
